import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { RootState } from "../../app/store";
import defaultIcon from "../../img/icons/dark/image.svg";
import { format } from "date-fns";
import { useAcceptPropositionMutation, useCancelSubscriptionMutation, useGetStatisticsCategoryMutation, useRefundPaymentMutation, useRenewSubscriptionMutation } from "../../redux/api";
import SubscriptionPaymentItem from "../../components/SubscriptionPaymentItem";
import "./style.scss";
import PaymentItem from "../../components/PaymentItem";
import Modal from 'rsuite/Modal';
import Button from 'rsuite/Button';
import Checkbox from 'rsuite/Checkbox';
import 'rsuite/Modal/styles/index.css';
import 'rsuite/Button/styles/index.css';
import 'rsuite/Checkbox/styles/index.css';
import { cloudStorage } from "@telegram-apps/sdk";
import { setSelectedStatisticItem } from "../../redux/slices/windowSlice";

const SubscriptionInfo = () => {
    const dispatch = useAppDispatch();
    const { selectedStatisticItem, selectedStatisticType, statisticItems, projectId } = useAppSelector(
        (state: RootState) => state.windowSlice
    );

    const [refund, { data: refundData, isLoading: isLoadingRefundation, isError: isErrorRefundation, isSuccess: isSuccessRefundation}] = useRefundPaymentMutation();
    const [loadStatistic, { data, isLoading, isError, isSuccess }] = useGetStatisticsCategoryMutation();

    const [currentPage, setCurrentPage] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [cancelNow, setCancelNow] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const itemsPerPage = 3;

    const [password, setPassword] = useState("");
    const [selectedKey, setSelectedKey] = useState("");

    useEffect(() => {
        if (process.env.NODE_ENV === "development") {
            const password = localStorage.getItem("b4chat-password-hash-admin");
            setPassword(password);
        } else {
            cloudStorage
                .getItem("b4chat-password-hash-admin")
                .then((password) => {
                    setPassword(password);
                });
        }
    }, []);

    const formatPrice = (price) => {
        const { amount, currency, interval, interval_unit } = price;
        let intervalText = "";

        switch (interval_unit) {
            case "hour":
                intervalText = interval === 1 ? "час" : "часа";
                break;
            case "day":
                intervalText = interval === 1 ? "день" : "дня";
                break;
            case "week":
                intervalText = interval === 1 ? "неделя" : "недели";
                break;
            case "month":
                intervalText = interval === 1 ? "месяц" : "месяца";
                break;
            case "year":
                intervalText = interval === 1 ? "год" : "года";
                break;
            default:
                intervalText = interval_unit;
                break;
        }

        return `${amount} ${currency} / каждые ${interval} ${intervalText}`;
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return format(date, "dd.MM.yyyy в HH:mm");
    };

    const getRenewInformation = (billingInformation, status) => {
        const { renew_at, valid_until } = billingInformation;

        if (renew_at === null && status === "canceled") {
            return (
                "Бот автоматически удалит Вас из канала " +
                formatDate(valid_until) +
                "."
            );
        } else if (renew_at === null && status === "active") {
            return (
                "Состоится " + formatDate(valid_until) + "."
            );
        } else if (
            renew_at !== null &&
            (status === "active" || status === "processing")
        ) {
            return "Следующее списание " + formatDate(renew_at) + ".";
        } else if (
            status === "inactive"
        ) {
            return "Срок действия подписки истёк " + formatDate(valid_until) + ".";
        }  else {
            return "";
        }
    };

    const handleRefund = (item) => {
        setSelectedItem(item);
        setShowModal(true);
    }

    const handleCancel = () => {
        setShowModal(false);
        setCancelNow(false);
    }

    const handleConfirmRefund = () => {
        console.log(selectedItem.id, cancelNow);
        refund({ project_id: projectId, payment_id: selectedItem.id, with_cancel: cancelNow }).unwrap().then(() => {
            loadStatistic({ type: selectedStatisticType, project_id: projectId, password: password }).unwrap().then((response) => {
                let item = response.find((item) => item.id === selectedStatisticItem.id);
                dispatch(setSelectedStatisticItem(item));
                setShowModal(false);
                setCancelNow(false);
            });
            
        });  
    }

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    if (!selectedStatisticItem) {
        return null;
    }

    const offset = currentPage * itemsPerPage;
    const currentPayments = selectedStatisticItem.payments.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(selectedStatisticItem.payments.length / itemsPerPage);

    return (
        <div className="subscription-new">
            <div className="subscription-new_container">
                <div className="subscription-new_wrapper">
                    <div className="subscription-new_main-block">
                        <div className="subscription-new_main-block_information">
                            <div className="subscription-new_main-block_information_icon">
                                <img
                                    src=""
                                    alt=""
                                    className="subscription-new_main-block_information_icon_img"
                                />
                                <img
                                    src={defaultIcon}
                                    alt="Image"
                                    className="subscription-info_main-block_information_icon_img-default"
                                />
                            </div>
                            <div className="subscription-new_main-block_information_details">
                                <span className="subscription-new_main-block_information_details_title">
                                    {selectedStatisticItem.title}
                                </span>
                                <span className="subscription-new_main-block_information_details_plan">
                                    {selectedStatisticItem.title_friendly}
                                </span>
                            </div>
                        </div>
                        <div className="subscription-new_main-block_plan-details">
                            <span className="subscription-new_main-block_plan-details_price">
                                {formatPrice(selectedStatisticItem.price)}
                            </span>
                            <span className="subscription-new_main-block_plan-details_renew-information">
                                {getRenewInformation(selectedStatisticItem.billing_information, selectedStatisticItem.status)}
                            </span>
                        </div>
                    </div>
                    <span className="subscription-new_text">Списания по данной подписке</span>
                    {currentPayments.length > 0 && (
                        currentPayments.map((item, index) => (
                            <PaymentItem key={index} item={item} onClick={() => handleRefund(item)} />
                        ))
                    )}
                    <ReactPaginate
                        previousLabel={"←"}
                        nextLabel={"→"}
                        pageCount={pageCount}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={1}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        activeClassName={"active"}
                    />
                </div>
            </div>
            <Modal open={showModal} onClose={handleCancel} size="xs">
                <Modal.Header>
                    <Modal.Title>Возврат оплаты</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Checkbox checked={cancelNow} onChange={(value, checked) => setCancelNow(checked)}>Также отменить подписку</Checkbox>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleConfirmRefund} appearance="primary">Возврат</Button>
                    <Button onClick={handleCancel} appearance="subtle">Отмена</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default SubscriptionInfo;